import { deleteJson, getJson, putJson } from './client'
import type { ModelSpend, SettingField, SettingsView, SettingValue } from '../types/settings'

// The firm's own settings. Admins only, on reading as well as writing — what the firm's rivals are
// called and which domains are ours is the firm's business, not everyone's. The question is about the
// tenant, not about a pipeline, so it carries no org.
const settings = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/settings`
const one = (spoke: string, key: string) => `${settings(spoke)}/${encodeURIComponent(key)}`

export const settingsApi = {
  list: (spoke: string) => getJson<SettingsView>(settings(spoke), { org: undefined }),
  /** Save one setting. The answer is the field as it now reads, with its new source. */
  set: (spoke: string, key: string, value: SettingValue) => putJson<SettingField>(one(spoke, key), { value }),
  /** Drop the override: back to what the deploy chose, else what Scout ships with. */
  reset: (spoke: string, key: string) => deleteJson<SettingField>(one(spoke, key)),
  /** The model spend ledger: what the firm's turns would cost at list price (REQ-110). Admins only. */
  spend: (spoke: string) => getJson<ModelSpend>(`${settings(spoke)}/spend`, { org: undefined }),
}
